const Addresses = () => import('@monolith/legacy/modules/brand-account/pages/settings/addresses.page.vue');
const ShopSettings = () => import('@monolith/legacy/modules/brand-account/pages/settings/shop-settings.page.vue');
const MarketplaceStoreSetUp = () => import('@bc/account/setting/pages/marketplace-store-set-up/marketplace-store-set-up.vue');
const AccountBillingSettings = () => import('@monolith/legacy/modules/brand-account/pages/settings/billing-settings.page.vue');
const CompanyDetails = () => import('@monolith/legacy/modules/brand-account/pages/settings/company-details.page.vue');
const AccountSecurity = () => import('@monolith/legacy/modules/brand-account/pages/settings/account-security.page.vue');
import Store from '@monolith/legacy/store/index';
import { MenuOptions } from './types/settings';
import { RouteRecordRaw, NavigationGuardNext } from 'vue-router';
import { isEnabled, FeatureFlag } from '@monolith/legacy/services/features';

import { onBoardingFlowV2Guard } from '@core/routes/router-guard';

export function liveBrandGuard(_to, _from, next: NavigationGuardNext) {
  if (Store.getters['userIsCandidateBrand']) {
    next({ name: 'settings' });
  } else {
    next();
  }
}

export function brandGuard(_to, _from, next: NavigationGuardNext) {
  if (Store.getters['userIsBrand']) {
    next();
  } else {
    next({ name: 'settings' });
  }
}

export function holidayModeGuard(_to, _from, next: NavigationGuardNext) {
  if (isEnabled(FeatureFlag.HolidayMode)) {
    next();
  } else {
    next({ name: MenuOptions.COMPANY_DETAILS });
  }
}

export const getBrandAccountSettingsRoutes = (): RouteRecordRaw[] =>
  Store.getters.userIsRetailer
    ? []
    : [
        {
          path: '',
          redirect: { name: MenuOptions.BILLING_SETTINGS },
        },
        {
          path: '/account/settings/company-details',
          name: MenuOptions.COMPANY_DETAILS,
          component: CompanyDetails,
          beforeEnter: [brandGuard, onBoardingFlowV2Guard],
        },
        {
          path: '/account/settings/addresses',
          name: MenuOptions.ADDRESSES,
          component: Addresses,
          beforeEnter: [brandGuard, onBoardingFlowV2Guard],
        },
        {
          path: '/account/settings/shipping',
          name: MenuOptions.SHIPPING,
          component: MarketplaceStoreSetUp,
          beforeEnter: [brandGuard, onBoardingFlowV2Guard],
        },
        {
          path: '/account/settings/shop-settings',
          name: MenuOptions.SHOP_SETTINGS,
          component: ShopSettings,
          beforeEnter: [brandGuard, holidayModeGuard],
        },
        /** @deprecated - used only as redirect route for new separated address and shipping pages. */
        {
          path: '/account/settings/addresses-shipping',
          name: MenuOptions.ADDRESSES_AND_SHIPPING,
          redirect: () => ({ name: MenuOptions.SHIPPING }),
        },
        {
          path: '/account/settings/billing-settings',
          name: MenuOptions.BILLING_SETTINGS,
          component: AccountBillingSettings,
          beforeEnter: [liveBrandGuard],
        },
        {
          path: '/account/settings/account-security',
          name: MenuOptions.ACCOUNT_SECURITY,
          component: AccountSecurity,
          beforeEnter: [brandGuard, liveBrandGuard],
        },
        /** @deprecated - kept as redirect to ACCOUNT_SECURITY for old links/emails. */
        {
          path: '/account/settings/communications',
          name: MenuOptions.COMMUNICATIONS,
          redirect: { name: MenuOptions.ACCOUNT_SECURITY },
        },
        /** @deprecated - kept as redirect to ACCOUNT_SECURITY for old links/emails. */
        {
          path: '/account/settings/password',
          name: MenuOptions.PASSWORD,
          redirect: { name: MenuOptions.ACCOUNT_SECURITY },
        },
        /** @deprecated - kept as redirect to ACCOUNT_SECURITY for old links/emails. */
        {
          path: '/account/settings/email',
          name: MenuOptions.EMAIL,
          redirect: { name: MenuOptions.ACCOUNT_SECURITY },
        },
        /** @deprecated - kept as redirect to ACCOUNT_SECURITY for old links/emails. */
        {
          path: '/account/settings/two-factor',
          name: MenuOptions.TWO_FACTOR,
          redirect: { name: MenuOptions.ACCOUNT_SECURITY },
        },
      ];
